var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{on:{"playOrPauseBgMusic":_vm.playOrPause}})],1),_vm._v(" "),_c('audio',{ref:"music",attrs:{"src":"https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/bg-U38a8wRN.mp3","loop":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Desktop/annual-summary-2017/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2233986e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/Users/Mee/Desktop/annual-summary-2017/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 